import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { QueryRef } from 'apollo-angular';
import {
  Component, ViewEncapsulation, ViewChild, ChangeDetectionStrategy,
  Input, TemplateRef, AfterViewInit,
  OnInit, ChangeDetectorRef, ElementRef, EventEmitter, Renderer2, NgZone
} from '@angular/core';

import { timer, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Platform } from '@angular/cdk/platform';
import { MatIcon } from '@angular/material/icon';
import { MatButton, MatIconButton } from '@angular/material/button';
import { OnScrollViewDirective } from '../../scroll/on-scroll-view.directive';
import { PagedVirtualScrollerComponent, PageScrollerInfo } from '../paged-virtual-scroller/paged-virtual-scroller.component';

@UntilDestroy()
@Component({
    selector: 'block-horizontal',
    templateUrl: './block-horizontal.component.html',
    styleUrls: ['./block-horizontal.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [OnScrollViewDirective, MatButton, MatIcon, MatIconButton, PagedVirtualScrollerComponent]
})
export class BlockHorizontalComponent implements OnInit, AfterViewInit {

  @ViewChild(PagedVirtualScrollerComponent, { static: false }) pvs: PagedVirtualScrollerComponent;
 @ViewChild('viewport', {static: true}) viewportEl: ElementRef;

  @Input() itemHeight = 0;
  @Input() itemWidth = 0;
  @Input() rows: number;
  @Input() rowGap = 0;
  @Input() colGap = 0;
  @Input() itemTpl: TemplateRef<any>;
  @Input() autoScroll = false;
  @Input() buttonStyle: 'ios' | 'raised' | 'round' | 'none' = 'raised';
  @Input() itemsQuery: QueryRef<any>;
  @Input() pageSize: number;
  @Input() enableVirtualScroll = true;
  @Input() renderOnInVisible = false;
  @Input() renderOnTimeOut = -1;
  @Input() sender : 'header';



  pageChanged: EventEmitter<PageScrollerInfo> = new EventEmitter();
  currentPageInfo: PageScrollerInfo;
  private scrollTimer: Observable<number>;
  private isInView = false;
  private pauseAutoscroll = false;

  get isBOF(): boolean {
    return this.currentPageInfo?.isBOF ?? true;
  }

  get isEOF(): boolean {
    return this.currentPageInfo?.isEOF ?? false;
  }

  constructor(
    public platform: Platform,
    public cd: ChangeDetectorRef,
    private renderer: Renderer2,
    private zone: NgZone
  ) {
  }

  ngOnInit(): void {

    if (this.platform.isBrowser && this.autoScroll) {
      this.zone.runOutsideAngular(() => {
        this.scrollTimer = timer(3000, 5000);
        this.scrollTimer.pipe(
          untilDestroyed(this),
          filter(() => this.isInView && !this.pauseAutoscroll)
        ).subscribe(() => {
          this.pvs.nextPage();
        });
      });
    }

  }
  ngAfterViewInit(): void {
    this.pvs.pageChanged
    .pipe(
      untilDestroyed(this)
    )
    .subscribe(p => {
      this.currentPageInfo = p;
      this.pageChanged.emit(p);
      this.cd.detectChanges();
    });

    const el = this.viewportEl.nativeElement;
    const h = this.getRows() * (this.itemHeight + this.rowGap) - this.rowGap;
    this.renderer.setStyle(el, '--row-height', `${this.itemHeight}px` , 2 );
    this.renderer.setStyle(el, '--col-width', `${this.itemWidth}px` , 2 );
    this.renderer.setStyle(el, '--row-gap', `${this.rowGap}px` , 2 );
    this.renderer.setStyle(el, '--col-gap', `${this.colGap}px` , 2 );
    this.renderer.setStyle(el, '--grid-height', `${h}px` , 2 );

    this.cd.detectChanges();
  }

  getRows(): number {
    if (this.rows) {
      return this.rows;
    }
    if (this.viewportEl) {
      return Math.floor(this.viewportEl.nativeElement.clientHeight / (this.itemHeight + this.rowGap));
    } else {
      return 1;
    }
  }

  mouseEnter(): void {
    this.enableVirtualScroll = true;
    this.pauseAutoscroll = true;
  }

  mouseLeave(): void {
    this.pauseAutoscroll = false;
  }

  trackByFn(index, item): string {
    return index;
  }

  onViewStateChange(isVisible: boolean): void {
    this.isInView = isVisible;
  }
}
